export const TOUCH_DEVICE_OPTIONS = {
  delayTouchStart: 50,
}
